import React, { useState, useCallback } from 'react';
import { RefreshCw } from 'lucide-react';
import AdminLayout from '../../../components/Admin/Layout/AdminLayout';
import FooterBar from '../../../components/shared/FooterBar';
import SchedulerStatus from '../../../components/Admin/Settings/SchedulerStatus/SchedulerStatus';

export default function SchedulerStatusPage() {
  const [componentActions, setComponentActions] = useState(null);
  const [pagination, setPagination] = useState({ totalPages: 1, currentPage: 1, totalItems: 0, pageSize: 20, setCurrentPage: null });

  const handleActionsReady = useCallback((actions) => {
    setComponentActions(actions);
  }, []);

  const handlePaginationChange = useCallback((data) => {
    setPagination(data);
  }, []);

  return (
    <AdminLayout>
      <div className="min-h-full flex flex-col">
        <div className="bg-white border-b border-[#D5D9D9] px-4 sm:px-6 py-2 flex items-center justify-between sticky top-0 z-10">
          <h1 className="text-[14px] font-bold text-[#0F1111]">
            Scheduler Status {pagination.totalItems > 0 && <span className="font-normal text-[#565959]">({pagination.totalItems})</span>}
          </h1>
          {componentActions && (
            <button
              onClick={componentActions.onRefresh}
              disabled={componentActions.refreshing}
              className="p-1.5 rounded bg-white border border-[#D5D9D9] text-[#565959] hover:bg-[#F7F7F7] transition-colors disabled:opacity-50"
              title="Refresh"
            >
              <RefreshCw size={14} className={componentActions.refreshing ? 'animate-spin' : ''} />
            </button>
          )}
        </div>
        <div className="flex-1 p-3 sm:p-5">
          <SchedulerStatus renderActions={handleActionsReady} onPaginationChange={handlePaginationChange} />
        </div>
        <FooterBar
          totalPages={pagination.totalPages}
          currentPage={pagination.currentPage}
          onPageChange={(p) => pagination.setCurrentPage?.(p)}
          totalItems={pagination.totalItems}
          pageSize={pagination.pageSize}
        />
      </div>
    </AdminLayout>
  );
}
